import { apiClient } from "./client";

const api = apiClient;

// --- Listings search -------------------------------------------------------
export const searchAdminListings = (params) =>
  api.get("/admin/listings", { params }).then((r) => r.data);

export const getAdminListing = (ulid) =>
  api.get(`/admin/listings/${ulid}`).then((r) => r.data);

export const getRawListing = (rawUlid) =>
  api.get(`/admin/raw-listings/${rawUlid}`).then((r) => r.data);

// --- Stats / overview ------------------------------------------------------
export const getStatsOverview = () =>
  api.get("/admin/stats/overview").then((r) => r.data);

export const getCollectionsStats = () =>
  api.get("/admin/collections/stats").then((r) => r.data);

// --- Import runs -----------------------------------------------------------
export const listImportRuns = (params) =>
  api.get("/admin/import-runs", { params }).then((r) => r.data);

export const getImportRun = (ulid) =>
  api.get(`/admin/import-runs/${ulid}`).then((r) => r.data);

// --- Failed mappings -------------------------------------------------------
export const listFailedMappings = (params) =>
  api.get("/admin/failed-mappings", { params }).then((r) => r.data);

// --- Image health ----------------------------------------------------------
export const getImageHealthStats = () =>
  api.get("/admin/image-health/stats").then((r) => r.data);

export const runImageHealthBatch = () =>
  // Round-7 P0 — async dispatch (HTTP 202) avoids Cloudflare 524 when
  // the batch takes >100s. Old sync endpoint kept on backend for CLI
  // use; admin UI uses async + poll for results.
  api.post("/admin/image-health/run-once-async").then((r) => r.data);

export const finalizeStuckImportRun = (ulid, target_status = "partial") =>
  api
    .post(`/admin/import-runs/${ulid}/finalize`, null, { params: { target_status } })
    .then((r) => r.data);

export const resetStuckImageHealth = () =>
  api.post("/admin/image-health/reset-stuck").then((r) => r.data);

// --- Quality / Regression Worker (Batch 4 Section E + F) ------------------
export const getQualityHealthScore = () =>
  api.get("/admin/quality/health-score").then((r) => r.data);

export const getQualityHistory = (limit = 30) =>
  api.get("/admin/quality/history", { params: { limit } }).then((r) => r.data);

export const getQualityRun = (ulid) =>
  api.get(`/admin/quality/run/${ulid}`).then((r) => r.data);

export const runQualityNow = () =>
  api.post("/admin/quality/run-now").then((r) => r.data);

// --- Comparable Quality (Batch 5a Section D) ------------------------------
export const getComparableQualityLatest = () =>
  api.get("/admin/comparable-quality/latest").then((r) => r.data);

export const getComparableQualityIssues = (params = {}) =>
  api.get("/admin/comparable-quality/issues", { params }).then((r) => r.data);

export const runComparableQualityNow = () =>
  api.post("/admin/comparable-quality/run-now").then((r) => r.data);

// --- Price Changes (Batch 5b-1 Section 4) ---------------------------------
export const getPriceChangeRecent = (params = {}) =>
  api.get("/admin/price-changes/recent", { params }).then((r) => r.data);

export const getPriceChangeStats = (params = {}) =>
  api.get("/admin/price-changes/stats", { params }).then((r) => r.data);

export const getPriceChangeListing = (ulid) =>
  api.get(`/admin/price-changes/listing/${ulid}`).then((r) => r.data);

export const runPriceChangeProcessNow = () =>
  api.post("/admin/price-changes/process-now").then((r) => r.data);

// --- Explainability (Batch 4 Section G + Batch 5b-1 Section 1) -----------
export const getExplainability = (listingUlid) =>
  api.get(`/admin/explainability/${listingUlid}`).then((r) => r.data);

export const recheckListingImage = (ulid) =>
  api.post(`/admin/image-health/recheck/${ulid}`).then((r) => r.data);

// --- Known datasets --------------------------------------------------------
export const listKnownDatasets = () =>
  api.get("/admin/known-datasets").then((r) => r.data);

export const triggerKnownDatasetImport = (key) =>
  api.post(`/import/apify/known-dataset/${key}`).then((r) => r.data);

// --- DealFlow debug --------------------------------------------------------
export const getDealflowDebug = (vertical, params) =>
  api.get(`/dealflow/${vertical}/debug`, { params }).then((r) => r.data);

// --- Sprint Q O.1 — Feature Flag Management --------------------------------
export const getFeatureFlags = () =>
  api.get("/admin/settings/flags").then((r) => r.data);

export const setFeatureFlag = (flag, value) =>
  api
    .post("/admin/settings/flags", { flag, value })
    .then((r) => r.data);

export const getFlagAudit = (params) =>
  api.get("/admin/settings/flags/audit", { params }).then((r) => r.data);

// --- Sprint Q O.2 — Market Recompute Controls ------------------------------
export const triggerMarketRecompute = (payload) =>
  // payload supports: vertical, country, source_market, dry_run,
  // listing_ids[], performance_markers_only, marker_types[]
  api.post("/admin/market/recompute", payload).then((r) => r.data);

export const getRecomputeJob = (jobId) =>
  api.get(`/admin/market/recompute/jobs/${jobId}`).then((r) => r.data);

export const getMarketStats = () =>
  api.get("/admin/market/stats").then((r) => r.data);

// --- Scheduler -------------------------------------------------------------
export const getSchedulerStatus = () =>
  api.get("/admin/scheduler/status").then((r) => r.data);

export const getSchedulerRuns = (params) =>
  api.get("/admin/scheduler/runs", { params }).then((r) => r.data);

// --- Country Backfill (Phase 2a — Country-First) ---------------------------
export const getCountryBackfillOverview = () =>
  api.get("/admin/country-backfill/overview").then((r) => r.data);

// body: { country, action, mode }
export const dispatchCountryBackfill = (payload) =>
  api.post("/admin/country-backfill", payload).then((r) => r.data);

// Poll a maintenance job (shared job framework).
export const getMaintenanceJob = (jobUlid) =>
  api.get(`/admin/maintenance/jobs/${jobUlid}`).then((r) => r.data);


// --- Apple IAP Monitor (P0 Hotfix 2026-07-08) ------------------------------
export const getIapMonitor = (hours = 24) =>
  api.get("/admin/apple/iap-monitor", { params: { hours } }).then((r) => r.data);

export const rescueAppleByTransaction = (payload) =>
  // payload: { user_email?, user_ulid?, transaction_id?, original_transaction_id? }
  api.post("/admin/apple/rescue-by-transaction", payload).then((r) => r.data);

export const rescueAppleManual = (payload) =>
  // payload: { user_email?, user_ulid?, days?, reason? }
  api.post("/admin/apple/rescue-manual", payload).then((r) => r.data);
